<div class="horizontal-center-container py-5">
  <div>
    <div class="d-flex justify-content-center">
      <lottie-player
        src="/assets/animations/done.json"
        background="transparent"
        speed="1"
        style="width: 200px; height: 150px"
        loop
        autoplay
        alt="no-results"
      ></lottie-player>
    </div>
    <div>
      <h6 class="title flex-center text-center">
        {{ title || 'shared.process-completed.title' | translate }}
      </h6>
      <p *ngIf="!disableDescription" class="flex-center text-center">
        {{ description || 'shared.process-completed.description' | translate }}
      </p>
    </div>
  </div>
</div>
